import { render, staticRenderFns } from "./MAppBottom.vue?vue&type=template&id=5d0eca32&scoped=true"
import script from "./MAppBottom.vue?vue&type=script&lang=ts"
export * from "./MAppBottom.vue?vue&type=script&lang=ts"
import style0 from "./MAppBottom.vue?vue&type=style&index=0&id=5d0eca32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0eca32",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AIcon: require('/codebuild/output/src780183439/src/app/components/atoms/Media/AIcon.vue').default})
